import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiCustodyClaim } from "@/api";
import type { CustodyClaimRequest, CustodyClaimResponse } from "@/api/types";

export function useCustodyClaim() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      data: CustodyClaimRequest
    ): Promise<CustodyClaimResponse> => {
      const res = await ApiCustodyClaim(data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["custodyOrders"] });
      queryClient.invalidateQueries({ queryKey: ["userCustodyInfo"] });
      queryClient.invalidateQueries({ queryKey: ["balanceV2"] });
    },
  });
}
